import React, { useEffect, useState } from "react";
import { useSearch } from "hooks/useSearch";
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import RegularButton from "components/CustomButtons/Button";
import { useDispatch, useSelector } from "react-redux";
import { useToggle } from "hooks/useToggle";
import { useValidateReload } from "hooks/useValidateReload";
import Add from "@mui/icons-material/Add";
import { handleAdminUnitsInputsAction } from "redux/actions/adminUnits/adminUnitsActions";
import { AdminUnitsForm } from "./AdminUnitsForm";
import { columns } from "./columns";
import { getUnitsConfigs } from "redux/actions/unitsSection/unitsAction";
import { getGlobalInvoicesCRELicenses } from "redux/actions/globalInvoices/globalInvoicesAction";
import { useRevalidateFetch } from "hooks/useRevalidateFetch";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import { unitsSelector } from "./selector";
import { ADMIN_UNIT_LOADINGS, adminUnitsTypes } from "redux/reducers/adminUnits/types";

const tableKey = "adminUnits";
const loadings = [
  "get",
  "create",
  "update",
  "delete",
  "employees",
  "updateUnitEmployee",
  "updatePercentage",
  "unitToInventory",
  "toggleTerminal",
  "createBill",
  "editBill",
  ADMIN_UNIT_LOADINGS.CREDIT_LIMIT,
  ADMIN_UNIT_LOADINGS.UNIT_CUSTOMERS,
  ADMIN_UNIT_LOADINGS.GET_CREDIT_CONDITIONS,
  ADMIN_UNIT_LOADINGS.UPDATE_CREDIT_CONDITIONS,
];

export const AdminUnitsView = () => {
  const dispatch = useDispatch();
  const unitsConfigArr = useSelector((state) => unitsSelector(state));
  const { station } = useSelector(({ adminUnits }) => adminUnits);
  const { buildTableConfig, setSnackbar } = useSearch();
  const { isLoadingComp, configTables } = useSelector(({ search }) => search);
  const loading = isLoadingComp?.loadingUnits || false;
  const { creLicenses } = useSelector(({ globalInvoices }) => globalInvoices);

  useRevalidateFetch(getGlobalInvoicesCRELicenses, creLicenses);
  const [open, setOpen] = useToggle();
  const [units, setUnits] = useState([]);

  useValidateReload(loadings);
  const handleSubmit = () => {
    if (!station) {
      setSnackbar("Seleccione una planta.", "warning");
      return;
    }
    dispatch(getUnitsConfigs(station.id, adminUnitsTypes.GET_ADMIN_UNITS));
  };

  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey);
  }, []);

  useEffect(() => {
    if (
      station?.id &&
      unitsConfigArr?.length > 0 &&
      unitsConfigArr[0].idStation === station?.id
    ) {
      setUnits(unitsConfigArr);
    } else {
      setUnits([]);
    }
  }, [station?.id, unitsConfigArr]);

  return (
    <>
      <CardTable
        data={units}
        columns={columns}
        hasHeader
        blockBtn
        title="Administración de Unidades"
        icon={<LocalShippingIcon />}
        isLoading={loading}
        noDataText={
          !station
            ? "Seleccione una planta y presione buscar"
            : "No hay unidades registradas para esta planta"
        }
        tableContent={
          <TableInputs
            reducer={tableKey}
            stations
            dispatchAction={handleAdminUnitsInputsAction}
            loading={loading}
            submitAction={handleSubmit}
            preventEvent
          />
        }
        tableKey={tableKey}
        hasControl
        controls={
          <RegularButton round justIcon color="info" onClick={setOpen}>
            <Add style={{ margin: 0 }} />
          </RegularButton>
        }
      />
      {open && <AdminUnitsForm setOpen={setOpen} open={open} />}
    </>
  );
};
